var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2512 24.1451C72.2512 21.1536 74.6576 18.7285 77.6262 18.7285C80.5947 18.7285 83.0012 21.1536 83.0012 24.1451C83.0012 27.1367 80.5947 29.5618 77.6262 29.5618C74.6576 29.5618 72.2512 27.1367 72.2512 24.1451Z",
    fill: "#DB0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7512 25.4993C36.6506 25.4993 25.2199 37.0187 25.2199 51.2285C25.2199 65.4383 36.6506 76.9576 50.7512 76.9576C64.8517 76.9576 76.2824 65.4383 76.2824 51.2285C76.2824 37.0187 64.8517 25.4993 50.7512 25.4993ZM33.2824 51.2285C33.2824 41.506 41.1034 33.6243 50.7512 33.6243C60.3989 33.6243 68.2199 41.506 68.2199 51.2285C68.2199 60.951 60.3989 68.8326 50.7512 68.8326C41.1034 68.8326 33.2824 60.951 33.2824 51.2285Z",
    fill: "#DB0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0143 1.57398C60.3815 -0.524659 41.121 -0.524659 22.4882 1.57398C11.6734 2.79206 2.94258 11.3775 1.67111 22.3329C-0.557035 41.5312 -0.557035 60.9258 1.67111 80.124C2.94258 91.0794 11.6734 99.6649 22.4882 100.883C41.121 102.982 60.3814 102.982 79.0143 100.883C89.8291 99.6649 98.5599 91.0794 99.8314 80.124C102.06 60.9258 102.06 41.5312 99.8314 22.3329C98.5599 11.3775 89.8291 2.79206 79.0143 1.57398ZM23.3837 9.6487C41.4214 7.6171 60.0811 7.6171 78.1188 9.6487C85.2681 10.4539 90.9951 16.1393 91.8234 23.2768C93.9788 41.8479 93.9788 60.609 91.8234 79.1802C90.9951 86.3176 85.2681 92.003 78.1188 92.8082C60.0811 94.8398 41.4214 94.8398 23.3837 92.8082C16.2344 92.003 10.5074 86.3176 9.67902 79.1802C7.52366 60.609 7.52366 41.8479 9.67902 23.2768C10.5074 16.1393 16.2344 10.4539 23.3837 9.6487Z",
    fill: "#DB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram3);
export default __webpack_public_path__ + "static/media/instagram3.32edf83b42e78ecccc2864898ad2971b.svg";
export { ForwardRef as ReactComponent };